import { ITransportPlan2 } from 'features/TransportPlan'
import { Factory } from 'fishery'

import { ShipmentInterface } from '../domain/ShipmentInterface'

export const shipmentStoreMockInstance = {
  _id: 'S57509',
  timezone: '',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  pickup: {} as any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  delivery: {} as any,
  isOriginEUCountry: false,
  documents_id: [
    '5f1e83e7db0121001b93b467',
    '5f2128539b6171001ba8b51f',
    '5f21285b13da4e001bdfa045',
    '5f27d72885936ca852ddd427',
    '5f3229bab7afc72a438b1da4',
  ],
  packingLists: [],
  packingListsCopy: [],
  containers: [
    {
      type: '45GP',
      containerNumber: 'TKRU4014352',
      _id: '5ef1a46cd98150001bf96fe1',
      sealNumber: '',
      grossWeight: null,
      netWeight: null,
      customerReference: '',
      customerData: {
        earliestETW: null,
        latestETW: null,
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
    } as any,
  ],
  requiredActions: [],
  billingAddress: {
    street: 'Moosacher Str.',
    streetNumber: '88',
    street2: '',
    postalCode: '80809',
    city: 'Munich',
    state: 'Bavaria',
    country: 'Germany',
    salutation: 'Mr.',
    firstName: 'Martin',
    lastName: 'Helfer',
    companyName: 'wLabels GmbH',
    vatId: 'DE815504701',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  } as any,
  cargo: [
    {
      type: 'fcl',
      containerType: '45GP',
      quantity: 1,
    },
  ],
  createdAt: '2020-06-23T06:42:52.978Z',
  customerReference: '29007939, 29008034, 29008179',
  incoTerms: 'EXW',
  opsData: {
    class: 'EU Imp',
    star: true,
  },
  origin: {
    _id: 'ChIJOfP6uYA4TjQR_8lO6ZvUB_Q',
    types: ['address'],
    location: {
      lat: 28.6474547,
      lng: 121.2676047,
    },
    street: '',
    streetNumber: '',
    city: 'Taizhou',
    state: '',
    country: 'China',
    countryCode: 'CN',
    postalCode: '318020',
    googlePlace: 'ChIJOfP6uYA4TjQR_8lO6ZvUB_Q',
    description: '',
    googplace_id: '',
    googplace_types: [],
    place_id: '',
  },
  destination: {
    _id: 'ChIJ_8KGEIxXBEcRLQ6tYcjZFbM',
    types: ['address'],
    location: {
      lat: 52.3155297,
      lng: 17.0729118,
    },
    street: 'Żernicka',
    streetNumber: '22',
    city: 'Robakowo',
    state: 'Wielkopolskie',
    country: 'Poland',
    countryCode: 'PL',
    postalCode: '62-023',
    googlePlace: 'ChIJ_8KGEIxXBEcRLQ6tYcjZFbM',
    description: '',
    googplace_id: '',
    googplace_types: [],
    place_id: '',
  },
  pickupDetails: {
    companyName: 'Anji Daigao Furniture Co., Ltd.',
    street: 'Zone 2, Sunshine Industrial Park, Anji County, Zhejiang, 313300, China',
    streetNumber: '.',
    city: 'Taizhou',
    postalCode: '318020',
    country: 'China',
    instructions: '.',
    _id: '5ef1a55ab7cf5f001bdb3fca',
  },
  deliveryDetails: {
    _id: '5e5640f156d8b2001b411e81',
    companyName: 'Clipper Logistics, c/o Westwing',
    street: 'Zernika',
    streetNumber: '22',
    city: 'Dworzyska',
    postalCode: '62-023',
    country: 'Poland',
    instructions: 'Building 7/8',
  },
  eoriNumber: 'DE595440140437238',
  hsCodesCount: 1,
  insurance: [],
  isStackable: false,
  quoteOption: {
    _id: '5ee9f4f657a1dc001b7936c0',
    bookableUntil: new Date('2020-06-27T06:58:50.757Z'),
    destinationCustomsQuote: {
      lineItems: [
        {
          type: 'customs',
          name: 'Customs',
          code: null,
          description: '',
          quantity: 1,
          unitPrice: {
            value: 58.5,
            code: 'EUR',
          },
          total: {
            value: 58.5,
            code: 'EUR',
          },
          currencyExchangeRateId: '5ee9f4f610eb07001b40a931',
          reference: [],
          totalEUR: 58.5,
          exchangeRate: 1,
        },
      ],
      type: 'standard',
    },
    handlingFeeLineItem: {
      type: 'handling',
      name: 'FreightHub Handling Fee',
      code: null,
      description: 'Our handling fee for your booking',
      quantity: 1,
      unitPrice: {
        value: 0,
        code: 'EUR',
      },
      total: {
        value: 0,
        code: 'EUR',
      },
      currencyExchangeRateId: '5ee9f4f610eb07001b40a931',
      reference: [],
      totalEUR: 0,
      exchangeRate: 1,
    },
    insuranceQuote: null,
    isManual: true,
    originCustomsQuote: {
      lineItems: [],
      type: 'standard',
    },
    routeQuotes: {
      mainQuote: {
        lineItems: [
          {
            type: 'freight',
            name: 'Freight',
            code: null,
            description: '',
            quantity: 1,
            unitPrice: {
              value: 5550,
              code: 'USD',
            },
            total: {
              value: 5550,
              code: 'USD',
            },
            currencyExchangeRateId: '5ee9f4f610eb07001b40a931',
            reference: ['FAKE_MAIN_ID'],
            totalEUR: 5038.33,
            exchangeRate: 1.10155626,
          },
        ],
        mode: 'rail',
        route: {
          airline: null,
          carrier_id: 'FCN',
          cutOff: 3,
          daysOfDeparture: ['thu'],
          duration: 1296000000,
          eta: new Date('2020-06-10T15:05:04.535Z'),
          etd: new Date('2020-06-10T15:05:04.535Z'),
          frequency: 'weekly',
          journey: {
            origin: {
              _id: 'R-CNYIU',
              name: 'Yiwu Railway Station',
              countryCode: 'CN',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [120.070268, 29.306354],
              },
            },
            destination: {
              _id: 'R-PLWAW',
              name: 'Warsaw Railway Station',
              countryCode: 'PL',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [21.006725, 52.231958],
              },
            },
          },
          routeSchedule: null,
          scheduleReference: '',
          transportMode: 'rail',
          segments: [],
        },
        additionalCharges: [],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
        source: '' as any,
        rates: [
          {
            _id: 'FAKE_MAIN_ID',
            carrier_id: null,
            contractNumbers: ['WE'],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
          } as any,
        ],
      },
      postQuote: {
        lineItems: [],
        mode: 'truck',
        route: {
          airline: null,
          carrier_id: 'OTHER',
          cutOff: null,
          daysOfDeparture: null,
          duration: null,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
          eta: '' as any,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
          etd: '' as any,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
          frequency: '' as any,
          journey: {
            origin: {
              _id: 'R-PLWAW',
              name: 'Warsaw Railway Station',
              countryCode: 'PL',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [21.006725, 52.231958],
              },
            },
            destination: {
              _id: 'R-PLWAW',
              name: 'Warsaw Railway Station',

              countryCode: 'PL',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [21.006725, 52.231958],
              },
            },
          },
          routeSchedule: null,
          scheduleReference: '',
          transportMode: 'truck',
          segments: [],
        },
        additionalCharges: [],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
        source: {} as any,
        rates: [],
      },
    },
    sheet_id: '5ee9befa46912c001ba7d9ff',
    type: 'fcl',
    vgmQuote: null,
    voucherQuote: null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  } as any,
  state: 'active',
  type: 'lcl',
  goodsValue: null,
  customsIssuance: true,
  customsBondType: null,
  vgm: false,
  dangerousGoods: false,
  specialEquipment: false,
  bookedByFreightHub: true,
  originCustomsType: 'standard',
  destinationCustomsType: 'standard',
  mode: 'rail',
  totalEUR: 5946.83,
  consigneeContact: {
    _id: '59db8f8cdc6a9500129e6b81',
    companyName: 'wLabels GmbH',
    contactPerson: 'PRL Team',
    address: 'Moosacher Straße 88, 80809 Muenchen',
    phone: '+4989550544417',
    email: 'supply.wlabels@westwing.de',
  },
  shipperContact: {
    _id: '5ef1a53d06487f001c3f5511',
    companyName: 'Anji Daigao Furniture Co., Ltd.',
    contactPerson: 'George',
    address: 'Zone 2, Sunshine Industrial Park, Anji County, Zhejiang, 313300, China',
    phone: '+86 572 5086968',
    email: 'deko4@dkfurniture.com.cn',
  },
  deliveryDate: new Date('2020-08-21T17:00:00.000Z'),
  bookingNumber: 'SHWERLHW20070079',
  additionalInformation: 'TKRU4014352',
  mblNumber: '12472532',
  hblNumber: 'CNSHARE0070031',
  hblType: 'express',
  lineItems: [
    {
      meta: {
        chargeableWeight: 123.5,
      },
    },
  ],
} as unknown as ShipmentInterface

export const shipmentStoreFactory = Factory.define<ShipmentInterface>(({ transientParams }) => ({
  ...shipmentStoreMockInstance,
  ...transientParams,
}))

export const shipmentProccessedMock = {
  _id: 'S57509',
  timezone: '',
  pickup: {},
  delivery: {},
  isOriginEUCountry: false,
  documents_id: [
    '5f1e83e7db0121001b93b467',
    '5f2128539b6171001ba8b51f',
    '5f21285b13da4e001bdfa045',
    '5f27d72885936ca852ddd427',
    '5f3229bab7afc72a438b1da4',
  ],
  packingLists: [[]],
  packingListsCopy: [false],
  containers: [
    {
      type: '45GP',
      containerNumber: 'TKRU4014352',
      sealNumber: '',
      grossWeight: null,
      customerReference: '',
      _id: '5ef1a46cd98150001bf96fe1',
      netWeight: null,
      customerData: {
        earliestETW: null,
        latestETW: null,
      },
    },
  ],
  requiredActions: [],
  billingAddress: {
    companyName: 'wLabels GmbH',
    vatId: 'DE815504701',
    salutation: 'Mr.',
    firstName: 'Martin',
    lastName: 'Helfer',
    street: 'Moosacher Str.',
    streetNumber: '88',
    street2: '',
    postalCode: '80809',
    city: 'Munich',
    state: 'Bavaria',
    country: 'Germany',
  },
  cargo: [
    {
      type: 'fcl',
      containerType: '45GP',
      quantity: 1,
    },
  ],
  createdAt: '2020-06-23T06:42:52.978Z',
  customerReference: '29007939, 29008034, 29008179',
  incoTerms: 'EXW',
  origin: {
    _id: 'ChIJOfP6uYA4TjQR_8lO6ZvUB_Q',
    types: ['address'],
    location: {
      lat: 28.6474547,
      lng: 121.2676047,
    },
    street: '',
    streetNumber: '',
    city: 'Taizhou',
    state: '',
    country: 'China',
    countryCode: 'CN',
    postalCode: '318020',
    googlePlace: 'ChIJOfP6uYA4TjQR_8lO6ZvUB_Q',
    description: '',
    googplace_id: '',
    googplace_types: [],
    place_id: '',
  },
  destination: {
    _id: 'ChIJ_8KGEIxXBEcRLQ6tYcjZFbM',
    types: ['address'],
    location: {
      lat: 52.3155297,
      lng: 17.0729118,
    },
    street: 'Żernicka',
    streetNumber: '22',
    city: 'Robakowo',
    state: 'Wielkopolskie',
    country: 'Poland',
    countryCode: 'PL',
    postalCode: '62-023',
    googlePlace: 'ChIJ_8KGEIxXBEcRLQ6tYcjZFbM',
    description: '',
    googplace_id: '',
    googplace_types: [],
    place_id: '',
  },
  pickupDetails: {
    companyName: 'Anji Daigao Furniture Co., Ltd.',
    street: 'Zone 2, Sunshine Industrial Park, Anji County, Zhejiang, 313300, China',
    streetNumber: '.',
    city: 'Taizhou',
    postalCode: '318020',
    country: 'China',
    instructions: '.',
    _id: '5ef1a55ab7cf5f001bdb3fca',
  },
  deliveryDetails: {
    _id: '5e5640f156d8b2001b411e81',
    companyName: 'Clipper Logistics, c/o Westwing',
    street: 'Zernika',
    streetNumber: '22',
    city: 'Dworzyska',
    postalCode: '62-023',
    country: 'Poland',
    instructions: 'Building 7/8',
  },
  eoriNumber: 'DE595440140437238',
  hsCodesCount: 1,
  insurance: [],
  isStackable: false,
  quoteOption: {
    _id: '5ee9f4f657a1dc001b7936c0',
    bookableUntil: new Date('2020-06-27T06:58:50.757Z'),
    destinationCustomsQuote: {
      lineItems: [
        {
          type: 'customs',
          name: 'Customs',
          code: null,
          description: '',
          quantity: 1,
          unitPrice: {
            value: 58.5,
            code: 'EUR',
          },
          total: {
            value: 58.5,
            code: 'EUR',
          },
          currencyExchangeRateId: '5ee9f4f610eb07001b40a931',
          reference: [],
          totalEUR: 58.5,
          exchangeRate: 1,
        },
      ],
      type: 'standard',
    },
    handlingFeeLineItem: {
      type: 'handling',
      name: 'FreightHub Handling Fee',
      code: null,
      description: 'Our handling fee for your booking',
      quantity: 1,
      unitPrice: {
        value: 0,
        code: 'EUR',
      },
      total: {
        value: 0,
        code: 'EUR',
      },
      currencyExchangeRateId: '5ee9f4f610eb07001b40a931',
      reference: [],
      totalEUR: 0,
      exchangeRate: 1,
    },
    insuranceQuote: null,
    isManual: true,
    originCustomsQuote: {
      lineItems: [],
      type: 'standard',
    },
    routeQuotes: {
      mainQuote: {
        lineItems: [
          {
            type: 'freight',
            name: 'Freight',
            code: null,
            description: '',
            quantity: 1,
            unitPrice: {
              value: 5550,
              code: 'USD',
            },
            total: {
              value: 5550,
              code: 'USD',
            },
            currencyExchangeRateId: '5ee9f4f610eb07001b40a931',
            reference: ['FAKE_MAIN_ID'],
            totalEUR: 5038.33,
            exchangeRate: 1.10155626,
          },
        ],
        mode: 'rail',
        route: {
          airline: null,
          carrier_id: 'FCN',
          cutOff: 3,
          daysOfDeparture: ['thu'],
          duration: 1296000000,
          eta: new Date('2020-06-10T15:05:04.535Z'),
          etd: new Date('2020-06-10T15:05:04.535Z'),
          frequency: 'weekly',
          journey: {
            origin: {
              _id: 'R-CNYIU',
              name: 'Yiwu Railway Station',
              countryCode: 'CN',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [120.070268, 29.306354],
              },
            },
            destination: {
              _id: 'R-PLWAW',
              name: 'Warsaw Railway Station',
              countryCode: 'PL',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [21.006725, 52.231958],
              },
            },
          },
          routeSchedule: null,
          scheduleReference: '',
          transportMode: 'rail',
          segments: [],
        },
        additionalCharges: [],
        source: '',
        rates: [
          {
            _id: 'FAKE_MAIN_ID',
            carrier_id: null,
            contractNumbers: ['WE'],
          },
        ],
      },
      postQuote: {
        lineItems: [],
        mode: 'truck',
        route: {
          airline: null,
          carrier_id: 'OTHER',
          cutOff: null,
          daysOfDeparture: null,
          duration: null,
          eta: '',
          etd: '',
          frequency: '',
          journey: {
            origin: {
              _id: 'R-PLWAW',
              name: 'Warsaw Railway Station',
              countryCode: 'PL',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [21.006725, 52.231958],
              },
            },
            destination: {
              _id: 'R-PLWAW',
              name: 'Warsaw Railway Station',
              countryCode: 'PL',
              types: ['rail'],
              location: {
                type: 'Point',
                coordinates: [21.006725, 52.231958],
              },
            },
          },
          routeSchedule: null,
          scheduleReference: '',
          transportMode: 'truck',
          segments: [],
        },
        additionalCharges: [],
        source: {},
        rates: [],
      },
    },
    sheet_id: '5ee9befa46912c001ba7d9ff',
    type: 'fcl',
    vgmQuote: null,
    voucherQuote: null,
  },
  state: 'active',
  type: 'lcl',
  goodsValue: null,
  customsIssuance: true,
  customsBondType: null,
  vgm: false,
  dangerousGoods: false,
  specialEquipment: false,
  bookedByFreightHub: true,
  originCustomsType: 'standard',
  destinationCustomsType: 'standard',
  mode: 'rail',
  totalEUR: 5946.83,
  consigneeContact: {
    companyName: 'wLabels GmbH',
    contactPerson: 'PRL Team',
    address: 'Moosacher Straße 88, 80809 Muenchen',
    phone: '+4989550544417',
    email: 'supply.wlabels@westwing.de',
    _id: '59db8f8cdc6a9500129e6b81',
  },
  shipperContact: {
    companyName: 'Anji Daigao Furniture Co., Ltd.',
    contactPerson: 'George',
    address: 'Zone 2, Sunshine Industrial Park, Anji County, Zhejiang, 313300, China',
    phone: '+86 572 5086968',
    email: 'deko4@dkfurniture.com.cn',
    _id: '5ef1a53d06487f001c3f5511',
  },
  deliveryDate: new Date('2020-08-21T17:00:00.000Z'),
  bookingNumber: 'SHWERLHW20070079',
  additionalInformation: 'TKRU4014352',
  mblNumber: '12472532',
  hblNumber: 'CNSHARE0070031',
  hblType: 'express',
  lineItems: [
    {
      meta: {
        chargeableWeight: 123.5,
      },
    },
  ],
  opsAdditionalInformation: '',
}

export const shipmentTpMock = {
  shipmentId: 'S57509',
  origin: [
    {
      id: 'wqC8svwmp',
      trackables: [
        {
          trackableId: '629500e14d47f8001c32b2d4',
          correlation: {
            containerNumber: '',
          },
        },
      ],
      events: {
        crd: {
          actual: false,
          initialTimestamp: {
            type: 'date',
            date: '2022-05-30',
            reason: '',
            updatedBy: 'customer - at-booking-funnel-step',
            updatedOn: '2022-05-30T17:37:37.876Z',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
          revisedTimestamp: {
            type: 'date',
            date: '2022-05-30',
            reason: '',
            updatedBy: 'customer - at-booking-funnel-step',
            updatedOn: '2022-05-30T17:37:37.876Z',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
          aggregatedTimestamp: {
            type: 'date',
            date: '2022-05-30',
            reason: '',
            updatedBy: 'customer - at-booking-funnel-step',
            updatedOn: '2022-05-30T17:37:37.876Z',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
        },
      },
      eventOrder: [
        'crd',
        'dpr',
        'cgi',
        'cll',
        'vdl',
        'vat1',
        'container-discharged-transshipment-1',
        'container-loaded-transshipment-1',
        'vdt1',
        'vat2',
        'container-discharged-transshipment-2',
        'container-loaded-transshipment-2',
        'vdt2',
        'vat3',
        'container-discharged-transshipment-3',
        'container-loaded-transshipment-3',
        'vdt3',
        'vat4',
        'container-discharged-transshipment-4',
        'container-loaded-transshipment-4',
        'vdt4',
        'vad',
        'cdd',
        'cgo',
        'container-gate-in-at-place-of-delivery',
        'container-gate-out-at-place-of-delivery',
        'cer',
      ],
    },
  ],
  main: [
    {
      id: 'Vf847dhRd',
      route: {
        carrier_id: 'COSU',
        duration: 2858400000,
        etd: '2022-05-30T18:00:00.000Z',
        eta: '2022-07-02T20:00:00.000Z',
        journey: {
          origin: {
            _id: 'CNNBG',
            types: ['sea'],
            name: 'Ningbo Pt',
            countryCode: 'CN',
            unLocCode: 'CNNBO',
            isMainFor: ['APLU', 'UMLU'],
            timezoneIdentifier: 'Asia/Shanghai',
            location: {
              type: 'Point',
              coordinates: [121.4, 29.55],
            },
            tradelaneRegion: 'fareast',
          },
          destination: {
            _id: 'NLRTM',
            types: ['sea', 'rail', 'road', 'air'],
            name: 'Rotterdam',
            countryCode: 'NL',
            unLocCode: 'NLRTM',
            isMainFor: ['ACLU', 'ALIU', 'BLUEFREIGHT'],
            timezoneIdentifier: 'Europe/Amsterdam',
            location: {
              type: 'Point',
              coordinates: [4.3, 51.55],
            },
            tradelaneRegion: 'northerneurope',
          },
        },
        scheduleReference: '6292d6888b0f50001cced61e',
        transportMode: 'sea',
        type: 'mainRoute',
        routeSchedule: {
          _id: '6292d6888b0f50001cced61e',
          carrier_id: 'COSU',
          pol_id: 'CNNBG',
          pod_id: 'NLRTM',
          etd: '2022-05-30T18:00:00.000Z',
          eta: '2022-07-02T20:00:00.000Z',
          oceanLegs: [
            {
              pol_id: 'CNNBG',
              pod_id: 'NLRTM',
              etd: '2022-05-30T18:00:00.000Z',
              eta: '2022-06-30T20:00:00.000Z',
              service: {
                code: 'AEU6',
              },
              vessel: {
                name: 'APL LION CITY',
                code: 'V000003260',
                imo: 9631967,
              },
              voyage: '0FMA9W1MA',
              pol: {
                _id: 'CNNBG',
                types: ['sea'],
                name: 'Ningbo Pt',
                countryCode: 'CN',
                unLocCode: 'CNNBO',
                isMainFor: ['APLU', 'UMLU'],
                timezoneIdentifier: 'Asia/Shanghai',
                location: {
                  type: 'Point',
                  coordinates: [121.4, 29.55],
                },
                tradelaneRegion: 'fareast',
              },
              pod: {
                _id: 'NLRTM',
                types: ['sea', 'rail', 'road', 'air'],
                name: 'Rotterdam',
                countryCode: 'NL',
                unLocCode: 'NLRTM',
                isMainFor: ['ACLU', 'ALIU', 'BLUEFREIGHT'],
                timezoneIdentifier: 'Europe/Amsterdam',
                location: {
                  type: 'Point',
                  coordinates: [4.3, 51.55],
                },
                tradelaneRegion: 'northerneurope',
              },
            },
          ],
          source: 'cargosmart',
          cutOff: '2022-05-28T18:00:00.000Z',
          cutOffSource: 'carrier',
          pol: {
            _id: 'CNNBG',
            types: ['sea'],
            name: 'Ningbo Pt',
            countryCode: 'CN',
            unLocCode: 'CNNBO',
            isMainFor: ['APLU', 'UMLU'],
            timezoneIdentifier: 'Asia/Shanghai',
            location: {
              type: 'Point',
              coordinates: [121.4, 29.55],
            },
            tradelaneRegion: 'fareast',
          },
          pod: {
            _id: 'NLRTM',
            types: ['sea', 'rail', 'road', 'air'],
            name: 'Rotterdam',
            countryCode: 'NL',
            unLocCode: 'NLRTM',
            isMainFor: ['ACLU', 'ALIU', 'BLUEFREIGHT'],
            timezoneIdentifier: 'Europe/Amsterdam',
            location: {
              type: 'Point',
              coordinates: [4.3, 51.55],
            },
            tradelaneRegion: 'northerneurope',
          },
        },
        segments: [
          {
            duration: 2685600000,
            transportMode: 'sea',
            type: 'mainRoute',
            journey: {
              origin: {
                _id: 'CNNBG',
                types: ['sea'],
                name: 'Ningbo Pt',
                countryCode: 'CN',
                unLocCode: 'CNNBO',
                isMainFor: ['APLU', 'UMLU'],
                timezoneIdentifier: 'Asia/Shanghai',
                location: {
                  type: 'Point',
                  coordinates: [121.4, 29.55],
                },
                tradelaneRegion: 'fareast',
              },
              destination: {
                _id: 'NLRTM',
                types: ['sea', 'rail', 'road', 'air'],
                name: 'Rotterdam',
                countryCode: 'NL',
                unLocCode: 'NLRTM',
                isMainFor: ['ACLU', 'ALIU', 'BLUEFREIGHT'],
                timezoneIdentifier: 'Europe/Amsterdam',
                location: {
                  type: 'Point',
                  coordinates: [4.3, 51.55],
                },
                tradelaneRegion: 'northerneurope',
              },
            },
            etd: '2022-05-30T18:00:00.000Z',
            eta: '2022-06-30T20:00:00.000Z',
            durationInCalendarDays: 33,
          },
        ],
        durationInCalendarDays: 33,
      },
      trackables: [
        {
          trackableId: '629500e14d47f8001c32b2d4',
          correlation: {
            containerNumber: '',
          },
        },
      ],
      carriageStepType: 'main',
      events: {
        dpr: {
          actual: false,
          isActualCascaded: false,
        },
        cgi: {
          actual: false,
          isActualCascaded: false,
          initialTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T22:16:55.162Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T22:16:55.162Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-19',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Ningbo Pt',
            },
            utcOffsetHours: 8,
            revised: true,
            delay: 0,
          },
          revisedTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T22:16:55.162Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T22:16:55.162Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-19',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Ningbo Pt',
            },
            utcOffsetHours: 8,
            revised: true,
            delay: 0,
          },
          aggregatedTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T22:16:55.162Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T22:16:55.162Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-19',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Ningbo Pt',
            },
            utcOffsetHours: 8,
            revised: true,
            delay: 0,
          },
        },
        cll: {
          actual: false,
          isActualCascaded: false,
          initialTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T22:16:23.485Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T22:16:23.485Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-31',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Ningbo Pt',
            },
            utcOffsetHours: 8,
            revised: true,
            delay: 0,
          },
          revisedTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T22:16:23.485Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T22:16:23.485Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-31',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Ningbo Pt',
            },
            utcOffsetHours: 8,
            revised: true,
            delay: 0,
          },
          aggregatedTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T22:16:23.485Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T22:16:23.485Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-31',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Ningbo Pt',
            },
            utcOffsetHours: 8,
            revised: true,
            delay: 0,
          },
        },
        vdl: {
          actual: false,
          isActualCascaded: false,
          initialTimestamp: {
            type: 'date',
            date: '2022-05-30',
            reason: '',
            updatedBy: '',
            createdBy: '',
            updatedOn: '2022-05-13T06:49:02.852Z',
            createdOn: '2022-05-13T06:49:02.852Z',
            sourceType: 'internal',
            sourceId: 'transportplanning-core',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
          revisedTimestamp: {
            type: 'date',
            date: '2022-05-30',
            reason: '',
            updatedBy: '',
            createdBy: '',
            updatedOn: '2022-05-13T06:49:02.852Z',
            createdOn: '2022-05-13T06:49:02.852Z',
            sourceType: 'internal',
            sourceId: 'transportplanning-core',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
          aggregatedTimestamp: {
            type: 'date',
            date: '2022-05-30',
            reason: '',
            updatedBy: '',
            createdBy: '',
            updatedOn: '2022-05-13T06:49:02.852Z',
            createdOn: '2022-05-13T06:49:02.852Z',
            sourceType: 'internal',
            sourceId: 'transportplanning-core',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
        },
        vat1: {
          actual: false,
          isActualCascaded: false,
        },
        'container-discharged-transshipment-1': {
          actual: false,
          isActualCascaded: false,
        },
        'container-loaded-transshipment-1': {
          actual: false,
          isActualCascaded: false,
        },
        vdt1: {
          actual: false,
          isActualCascaded: false,
        },
        vat2: {
          actual: false,
          isActualCascaded: false,
        },
        'container-discharged-transshipment-2': {
          actual: false,
          isActualCascaded: false,
        },
        'container-loaded-transshipment-2': {
          actual: false,
          isActualCascaded: false,
        },
        vdt2: {
          actual: false,
          isActualCascaded: false,
        },
        vat3: {
          actual: false,
          isActualCascaded: false,
        },
        'container-discharged-transshipment-3': {
          actual: false,
          isActualCascaded: false,
        },
        'container-loaded-transshipment-3': {
          actual: false,
          isActualCascaded: false,
        },
        vdt3: {
          actual: false,
          isActualCascaded: false,
        },
        vat4: {
          actual: false,
          isActualCascaded: false,
        },
        'container-discharged-transshipment-4': {
          actual: false,
          isActualCascaded: false,
        },
        'container-loaded-transshipment-4': {
          actual: false,
          isActualCascaded: false,
        },
        vdt4: {
          actual: false,
          isActualCascaded: false,
        },
        vad: {
          actual: false,
          isActualCascaded: false,
          initialTimestamp: {
            type: 'date',
            date: '2022-07-02',
            reason: '',
            updatedBy: '',
            createdBy: '',
            updatedOn: '2022-05-13T06:49:02.852Z',
            createdOn: '2022-05-13T06:49:02.852Z',
            sourceType: 'internal',
            sourceId: 'transportplanning-core',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
          revisedTimestamp: {
            type: 'date',
            date: '2022-07-02',
            reason: '',
            updatedBy: '',
            createdBy: '',
            updatedOn: '2022-05-13T06:49:02.852Z',
            createdOn: '2022-05-13T06:49:02.852Z',
            sourceType: 'internal',
            sourceId: 'transportplanning-core',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
          aggregatedTimestamp: {
            type: 'date',
            date: '2022-07-02',
            reason: '',
            updatedBy: '',
            createdBy: '',
            updatedOn: '2022-05-13T06:49:02.852Z',
            createdOn: '2022-05-13T06:49:02.852Z',
            sourceType: 'internal',
            sourceId: 'transportplanning-core',
            confirmed: false,
            actual: false,
            revised: true,
            delay: 0,
          },
        },
        cdd: {
          actual: false,
          isActualCascaded: false,
          initialTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T23:03:17.895Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T23:03:17.895Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-31',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Rotterdam',
            },
            utcOffsetHours: 2,
            revised: true,
            delay: 0,
          },
          revisedTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T23:03:17.895Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T23:03:17.895Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-31',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Rotterdam',
            },
            utcOffsetHours: 2,
            revised: true,
            delay: 0,
          },
          aggregatedTimestamp: {
            updatedBy: 'Surbhi Singh',
            updatedOn: '2022-05-30T23:03:17.895Z',
            createdBy: 'Surbhi Singh',
            createdOn: '2022-05-30T23:03:17.895Z',
            sourceType: 'internal',
            sourceId: 'shipping-core',
            userRole: 'ops-manager',
            userId: '61324c21632ffa001dbce4aa',
            type: 'date',
            date: '2022-05-31',
            reason: '',
            confirmed: false,
            actual: false,
            causedBy: null,
            location: {
              name: 'Rotterdam',
            },
            utcOffsetHours: 2,
            revised: true,
            delay: 0,
          },
        },
        cgo: {
          actual: false,
          isActualCascaded: false,
        },
        'container-gate-in-at-place-of-delivery': {
          actual: false,
          isActualCascaded: false,
        },
        'container-gate-out-at-place-of-delivery': {
          actual: false,
          isActualCascaded: false,
        },
        cer: {
          actual: false,
          isActualCascaded: false,
        },
      },
      milestones: {
        cutoffs: {},
        pol: {},
        pod: {},
        demurrageDetentionOrigin: {
          demurrageDetentionDaysPerType: {},
          manualInformationPerType: {},
        },
        demurrageDetentionDestination: {
          demurrageDetentionDaysPerType: {},
          manualInformationPerType: {},
        },
        destinationDepot: {},
      },
      eventOrder: [
        'crd',
        'dpr',
        'cgi',
        'cll',
        'vdl',
        'vat1',
        'container-discharged-transshipment-1',
        'container-loaded-transshipment-1',
        'vdt1',
        'vat2',
        'container-discharged-transshipment-2',
        'container-loaded-transshipment-2',
        'vdt2',
        'vat3',
        'container-discharged-transshipment-3',
        'container-loaded-transshipment-3',
        'vdt3',
        'vat4',
        'container-discharged-transshipment-4',
        'container-loaded-transshipment-4',
        'vdt4',
        'vad',
        'cdd',
        'cgo',
        'container-gate-in-at-place-of-delivery',
        'container-gate-out-at-place-of-delivery',
        'cer',
      ],
    },
  ],
  transportType: 'fcl',
  transportMode: 'sea',
  serviceCompletion: {
    initial: {
      type: 'date',
      date: '2022-07-02',
      reason: '',
      updatedBy: '',
      createdBy: '',
      updatedOn: '2022-05-13T06:49:02.852Z',
      createdOn: '2022-05-13T06:49:02.852Z',
      sourceType: 'internal',
      sourceId: 'transportplanning-core',
      confirmed: false,
      actual: false,
      revised: true,
      delay: 0,
    },
    estimated: {
      type: 'date',
      date: '2022-07-02',
      reason: '',
      updatedBy: '',
      createdBy: '',
      updatedOn: '2022-05-13T06:49:02.852Z',
      createdOn: '2022-05-13T06:49:02.852Z',
      sourceType: 'internal',
      sourceId: 'transportplanning-core',
      confirmed: false,
      actual: false,
      revised: true,
      delay: 0,
    },
    serviceCompletionEventCode: 'vad',
  },
  incoTerm: 'FAS',
} as unknown as ITransportPlan2
